import React, { useEffect, useState } from 'react'
import Logo from "../../Assets/Images/logo.png"
import { Input, notification } from 'antd'
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import config, { axiosInstance } from '../Config';
import swal from 'sweetalert';
import secureLocalStorage from 'react-secure-storage';
import AccountContainer from "./AccountContainer"

const Login = () => {
    const [show_password, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (secureLocalStorage.getItem('credentials')) {
            navigate(`${config.appUrl}`);
        }
    }, []);


    const onHandleLogin = async (e) => {
        e.preventDefault();

        try {
            if (email && password) {
                setLoading(true);
                const formData = new FormData()
                formData.append('email', email)
                formData.append('password', password)
                formData.append('type', 0)

                const response = await axiosInstance.post(`/login`, formData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    }
                })

                // console.log('response', response.data)

                if (response.data.success == false && response.data.message == 'User is inactive') {
                    notification.open({
                        message: (
                            <div className="d-flex">
                                <div className="pr-10">
                                    <i
                                        className="icon-warning text-danger"
                                        style={{ fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div>You are InActive</div>
                            </div>
                        ),
                        description: "Please Contact Admin for Activation",
                    });

                    setLoading(false)
                    return;
                }

                if (response.data.success == true) {
                    notification.open({
                        message: (
                            <div className="d-flex">
                                <div className="pr-20">
                                    <i className="icon-check" style={{ color: "#4bb543" }}></i>
                                </div>
                                <div>Welcome {response.data.data.name}</div>
                            </div>
                        ),
                        description: "You are login successfully !",
                    });
                    secureLocalStorage.setItem("credentials", {
                        id: response?.data?.data?.id,
                        name: response?.data?.data?.name,
                        email: response?.data?.data?.email,
                        token : response?.data?.token,
                        role : response?.data?.data?.role,
                        image : response?.data?.data?.image,
                        has_seen_faq : response?.data?.data?.has_seen_faq,
                        lesson_type: response?.data?.data?.lesson_type
                    })
                    secureLocalStorage.setItem("FAQCompleted",true);
                    navigate(`${config.appUrl}`);

                } else {
                    notification.open({
                        message: (
                            <div className="d-flex">
                                <div className="pr-10">
                                    <i
                                        className="icon-warning text-danger"
                                        style={{ fontSize: "20px" }}
                                    ></i>
                                </div>
                                <div>Opp! Something went wrong.</div>
                            </div>
                        ),
                        description: "Invalid Email OR Password !",
                    });
                }

                setLoading(false);
            }
            else {
                notification.open({
                    message: (
                        <div className="d-flex">
                            <div className="pr-10">
                                <i
                                    className="icon-warning text-danger"
                                    style={{ fontSize: "20px" }}
                                ></i>
                            </div>
                            <div>Please Insert Data</div>
                        </div>
                    ),
                    description: "Email and Password are required",
                });
            }

        } catch (error) {
            console.log(error)
            setLoading(false)
            swal("", "Something went wrong!", "error")
        }
    };

    return (
        <div>
            {isLoading && (<Loader />)}

            <AccountContainer>
                <form onSubmit={onHandleLogin} className='px-md-5'>
                    <div className="ps-form__content px-5">
                        <div className='text-center mb-2'>
                            <img src={Logo} alt='No Logo' className='img-fluid w-50' />
                        </div>
                        <h5 className="mt-5 pt-md-4 display-4 fw-semibold text-center mb-2">Welcome Back</h5>
                        <p className="mb-5 text-center">Welcome To <span className='text-green'>Instructor Dashboard</span> </p>
                        
                        <div className="form-group form-forgot">
                            {/* <label htmlFor="" className='text-uppercase'>Email Address</label> */}
                            <Input
                                className="form-control form-field"
                                type="email"
                                placeholder="Email Address"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                }}
                            />
                        </div>
                        <div className="form-group form-forgot ">
                            {/* <label htmlFor="" className='text-uppercase'>password</label> */}
                            <div className="position-relative">
                                <Input
                                    className="form-control form-field"
                                    type={show_password ? "text" : "password"}
                                    placeholder="Password..."
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value)
                                    }}
                                />
                                <div className="bd-eye-open">
                                    <a onClick={() => setShowPassword(!show_password)}>
                                        <i
                                            className={
                                                show_password ? "icon-eye-crossed" : "icon-eye"
                                            }
                                        ></i>
                                    </a>
                                </div>
                            </div>

                        </div>
                        <div className="form-group ">
                            <div className="ps-checkbox text-end">
                                <Link to={`${config.appUrl}forgot-password`}>Forgot Password ?</Link>
                            </div>
                        </div>
                        <div className="form-group  ">
                            <button
                                type="submit"
                                className="ps-btn ps-btn--fullwidth btn-green color-white py-4"
                            >
                                Login as instructor
                            </button>
                        </div>

                        <div className='my-5 text-dark text-center'>
                            Don't have Account?
                            <Link to={`${config.appUrl}sign-up`}
                                className='text-decoration-none text-green'> Sign up</Link>
                        </div>
                    </div>
                </form>
            </AccountContainer>
        </div>
    )
}

export default Login